<template>
  <MainView />
</template>

<script setup lang="ts">
import MainView from "@/views/MainView.vue"
</script>

<style scoped>
</style>
